const CoupanNetworkWiseParser = {};

CoupanNetworkWiseParser.getCouponNetworkWiseParser = (res) => {

    if (res) {
        res = res.result.reverse();
      }
    
      if (!res) {
        return {};
      }
  };

  export {CoupanNetworkWiseParser}